"use client";

import { useEffect, useRef } from "react";

import { EVENTS } from "@/constants/analytics.constants";
import type { FormEventPayload } from "@/constants/formAnalytics.constants";
import useTagging from "@/hooks/useTagging";

/** Fires FORM_SUBMIT_ATTEMPT when a server-action form enters pending — avoids `onSubmit` on `<form action>`. */
export function useFormSubmitAttemptTag(
  isPending: boolean,
  formEvent: FormEventPayload,
) {
  const [, setTag] = useTagging();
  const pendingRef = useRef(false);

  useEffect(() => {
    if (isPending && !pendingRef.current) {
      setTag({
        event: EVENTS.FORM_SUBMIT_ATTEMPT,
        formEvent,
      });
    }
    pendingRef.current = isPending;
  }, [isPending, formEvent, setTag]);
}
